export const CREATE_UA_BIGQUERY_NAME = "create_user_analytics_bigquery";
export const CREATE_UA_BIGQUERY_DESC = `Registers a User Analytics BigQuery table configuration for a workspace (Organization).

Use when the user wants to connect Google Cloud BigQuery (project + dataset) to User Analytics.

Input:
- 'projectID' (required): Google Cloud project ID for BigQuery (string).
- 'datasetName' (required): BigQuery dataset name.
- 'eventSourceType' (optional): 'RAW_EVENTS_TABLES' | 'DERIVED_VIEW'. Defaults to RAW_EVENTS_TABLES.
- 'eventSourceViewName' (required for DERIVED_VIEW): BigQuery table or view name.
- 'selectedEventParamKeys' (optional): Event parameter keys to materialize for event-param filters.
- Provide workspace scope with exactly one of:
  - 'organizationId': Organization / workspace ID, OR
  - 'projectId': User Analytics Project ID (the tool resolves the organization from linked User Analytics).

Notes:
- Write operation (mutation). Requires confirmation.
- The returned config includes available/selected event parameter keys and event-param backfill status.
- If only projectId is given, the tool loads User Analytics on that project and derives organizationId.
- Use DERIVED_VIEW only when the user explicitly wants a derived table/view and provides the view name.
- After registration, User Analytics can use this BigQuery configuration (see list_bigquery).`;
